
import React from 'react';
import { usePersona } from '@/hooks/use-persona';
import { Sparkles } from 'lucide-react';

export function PersonaBanner() {
  const { personaConfig } = usePersona();

  return (
    <div className={`relative overflow-hidden rounded-xl p-4 sm:p-6 ${personaConfig.gradient} text-white shadow-lg`}>
      <div className="relative z-10">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-3">
          <span className="text-2xl sm:text-3xl">{personaConfig.icon}</span>
          <div className="flex-1">
            <h2 className="text-lg sm:text-xl font-bold">{personaConfig.name}</h2>
            <p className="text-sm opacity-90">{personaConfig.title}</p>
          </div>
        </div>
        <p className="text-sm opacity-90 mb-4 leading-relaxed">{personaConfig.description}</p>
        <div className="flex flex-wrap gap-2">
          {personaConfig.focus.map((focus) => (
            <span key={focus} className="px-2 sm:px-3 py-1 bg-white/20 rounded-full text-xs font-medium">
              {focus}
            </span>
          ))}
        </div>
      </div>
      <Sparkles className="absolute top-4 right-4 h-5 w-5 sm:h-6 sm:w-6 opacity-30" />
      <div className="absolute -bottom-6 -right-6 w-16 h-16 sm:w-24 sm:h-24 bg-white/10 rounded-full blur-xl" />
    </div>
  );
}
